import AuthService from '../services/auth.service';
import { broadcastAuthChanged, broadcastLogout } from '../services/auth-session-channel';
import moment from 'moment';

const user = JSON.parse(localStorage.getItem('user'));
const userProfileList = JSON.parse(localStorage.getItem('userProfileList'));
const navMenuList = JSON.parse(localStorage.getItem('navMenuList'));

export const auth = {
  namespaced: true,
  state: {
    user: user ? user : null,
    userProfileList: userProfileList ? userProfileList : null,
    navMenuList: navMenuList ? navMenuList : [],
    loginSessionId: null,
  },
  getters: {
    getUser: (state) => state.user,
    getNavMenuCategoryList: (state) => {
      let category = [
        ...new Set(
          state.navMenuList
            .filter((x) => x.webMenuCategory && x.visible == 'Y')
            .map((x) => x.webMenuCategory)
        ),
      ].sort();
      category.unshift(null);

      return category;
    },
    getNavMenu: (state) => {
      let mainMenu = state.navMenuList.filter(
        (x) => x.parentWebMenuId === null && x.visible == 'Y'
      );

      mainMenu.forEach((m) => {
        m.subMenuList = state.navMenuList.some(
          (x) => x.parentWebMenuId === m.webMenuId && x.visible == 'Y'
        )
          ? state.navMenuList.filter((x) => x.parentWebMenuId === m.webMenuId && x.visible == 'Y')
          : null;
      });

      return mainMenu;
    },
    isLoggined: (state) => {
      return (
        state.user !== null &&
        state.user.accessToken !== null &&
        Date.parse(state.user.tokenExpirationDate) > new Date()
      );
    },
    getRemainingSessionTime: (state) => (utcCurrentDate) => {
      return moment(state.user.tokenExpirationDate).diff(utcCurrentDate, 'seconds');
    },
    hasMenuAccess: (state) => (path) => {
      const rootPath = path.split('/')[1];
      const pathConfig = state.navMenuList.find((x) => x.path === `/${rootPath}`);
      if (pathConfig && pathConfig.visible === 'Y' && pathConfig.allowAll === 'Y') {
        return true;
      }

      return state.navMenuList && state.navMenuList.some((x) => x.path === path);
    },
    isAdmin: (state) => {
      return state.user.securityProfileName === 'Admin';
    },
    isFunder: (state) => {
      return state.user.securityProfileName === 'Funder';
    },
    isQualityControl: (state) => {
      return state.user.securityProfileName === 'Quality Control';
    },
  },
  actions: {
    login({ commit }, credential) {
      return AuthService.login(credential).then(
        (user) => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        (error) => {
          commit('logout');
          return Promise.reject(error);
        }
      );
    },
    logout({ commit }) {
      commit('logout');
    },
    getUserProfileList({ commit }) {
      return AuthService.getUserProfileList().then(
        (userProfileList) => {
          commit('getUserProfileListSuccess', userProfileList);
          return Promise.resolve(userProfileList);
        },
        (error) => {
          commit('logout');
          return Promise.reject(error);
        }
      );
    },
    getUserProfileListWithCredential({ commit }, credential) {
      return AuthService.getUserProfileListWithCredential(credential).then(
        (userProfileList) => {
          commit('dummyMutation');
          return Promise.resolve(userProfileList);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    setUserProfile({ commit }, userProfile) {
      commit('loginSuccess', userProfile);
    },
    switchUserProfile({ commit }, userInfo) {
      return AuthService.switchUserProfile(userInfo).then(
        (userProfile) => {
          commit('loginSuccess', userProfile);
          return Promise.resolve(userProfile);
        },
        (error) => {
          commit('logout', error);
          return Promise.reject(error);
        }
      );
    },
    getNavMenuList({ commit }) {
      return AuthService.getNavMenuList().then(
        (navMenuList) => {
          commit('getNavMenuListSuccess', navMenuList);
          return Promise.resolve(navMenuList);
        },
        (error) => {
          commit('logout');
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    // set user, userProfileList, menu list
    logout(state) {
      broadcastLogout();
      if (state.loginSessionId) {
        clearInterval(state.loginSessionId);
        state.loginSessionId = null;
      }

      state.user = null;
      state.userProfileList = null;
      state.navMenuList = null;

      localStorage.removeItem('user');
      localStorage.removeItem('userProfileList');
      localStorage.removeItem('navMenuList');

      location.href = '/auth/login';
    },
    loginSuccess(state, user) {
      state.user = user;
      localStorage.setItem('user', JSON.stringify(user)); // save user profile & token info
      broadcastAuthChanged();
    },
    // Hydrate Vuex from localStorage after another tab signals AUTH_CHANGED
    syncUser(state, user) {
      state.user = user;
    },
    loginFailure(state) {
      state.user = null;
      localStorage.removeItem('user');
    },
    getUserProfileListSuccess(state, userProfileList) {
      state.userProfileList = userProfileList;
      localStorage.setItem('userProfileList', JSON.stringify(userProfileList));
    },
    getUserProfileListFailure(state) {
      state.userProfileList = null;
      localStorage.removeItem('userProfileList');
    },
    getNavMenuListSuccess(state, navMenuList) {
      state.navMenuList = navMenuList;
      localStorage.setItem('navMenuList', JSON.stringify(navMenuList));
    },
    getNavMenuListFailure(state) {
      state.navMenuList = null;
      localStorage.removeItem('navMenuList');
    },
    setSessionId(state, sessionId) {
      state.sessionId = sessionId;
    },
    dummyMutation() {},
  },
};
